<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'StorageProductStorageTransfersList'
}
</script>